// Equonomy Logo - Equal Sign in Circle
// Represents equality, fairness, and balanced exchange

const EquonomyLogo = ({ className = "w-12 h-12", gradient = true }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {gradient && (
          <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#7C3AED" />
            <stop offset="100%" stopColor="#3B82F6" />
          </linearGradient>
        )}
      </defs>
      
      {/* Outer Circle */}
      <circle
        cx="50"
        cy="50"
        r="45"
        stroke={gradient ? "url(#logoGradient)" : "currentColor"}
        strokeWidth="6"
        fill="none"
      />
      
      {/* Equal Sign - Top Bar */}
      <rect
        x="25"
        y="38"
        width="50"
        height="7"
        rx="3.5"
        fill={gradient ? "url(#logoGradient)" : "currentColor"}
      />
      
      {/* Equal Sign - Bottom Bar */}
      <rect
        x="25"
        y="55"
        width="50"
        height="7"
        rx="3.5"
        fill={gradient ? "url(#logoGradient)" : "currentColor"}
      />
    </svg>
  );
};

export default EquonomyLogo;
